// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8 12L12.001 16.001L16.001 12L12.001 7.99902L8 12Z" fill="#80EAFF"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8 12L12.001 16.001L16.001 12L12.001 7.99902L8 12Z" style="fill: currentColor"/></svg>`;

export const XsollaPoint: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
